import { useQuery } from '@tanstack/react-query';
import {
  applyScenario,
  resourceState,
  shouldRetryMarketing,
  toMarketingError,
  type AudienceSegment,
  type ResourceState,
} from '@/features/marketing-shared';
import { fetchSmsAudiences, smsMarketingKeys } from '../api/sms-marketing-api';
import { useSmsMarketing } from './context';

/** Segmentações resolvidas da loja, com a partição por consentimento de SMS e telefone válido. */
export function useSmsAudiences(): { audiences: AudienceSegment[]; state: ResourceState } {
  const { idPassbook, scenario } = useSmsMarketing();
  const query = useQuery({
    queryKey: smsMarketingKeys.audiences(idPassbook),
    queryFn: () => fetchSmsAudiences(idPassbook),
    retry: shouldRetryMarketing,
    staleTime: 60_000,
  });
  const applied = applyScenario(query.data ?? [], resourceState(query, toMarketingError), scenario);
  return { audiences: applied.items, state: applied.state };
}
